import React from 'react';
import styled from 'styled-components';

interface FormContainerProps {
  children: React.ReactNode;
}

const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  /* padding: 20px; */
  
  @media (max-width: 767px) {
    padding: 0;
  }
`;

const FormContent = styled.div`
  width: 100%;
  
  @media (min-width: 768px) {
    max-width: 500px;
  }
`;

const FormContainer: React.FC<FormContainerProps> = ({ children }) => {
  return (
    <FormWrapper>
      <FormContent>
        {children}
      </FormContent>
    </FormWrapper>
  );
};

export default FormContainer;
